import React from 'react';
import { Helmet } from '@vuer-ai/react-helmet-async';
import { Box, Container, Typography, Paper } from '@mui/material';
import { DownloadDesktopAppPanel } from '@/common/components/DownloadDesktopAppPanel';
import { Background } from '@/common/auth/components/layout/components/Background';

const DownloadPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Download Studio Vault Desktop App</title>
        <meta
          name="description"
          content="Download the Studio Vault desktop application for macOS, Windows, or Linux"
        />
      </Helmet>

      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Background />

        <Container
          maxWidth="md"
          sx={{
            position: 'relative',
            zIndex: 1,
            transform: { xs: 'translateY(-10px)', md: 'translateY(-22px)' },
          }}
        >
          <Paper
            variant="hero"
            sx={{
              p: { xs: 3, md: 5 },
              position: 'relative',
              zIndex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3.5,
              borderRadius: 4,
              overflow: 'hidden',
            }}
          >
            <Typography
              variant="h3"
              component="h1"
              align="center"
              sx={{ fontSize: { xs: '1.8rem', md: '2.3rem' }, fontWeight: 800 }}
            >
              Download Studio Vault Desktop
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              align="center"
              sx={{ maxWidth: 680 }}
            >
              Native performance, automatic updates, and full local file system
              support for large music projects.
            </Typography>

            <Box
              sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}
            >
              <DownloadDesktopAppPanel />
            </Box>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default DownloadPage;
